<script>
import { includes, remove } from "lodash";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js"

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      ownedProductSelected: null,
      desiredProductSelected: null,
      ownedAccessorySelected: null,
      desiredAccessorySelected: null,
      pageModel: globalState.pageModel,
      currentUser: globalState.pageModel.user,
      productGridFilter: "owned_products",
      accessoryGridFilter: "owned_accessories",
      userUpdating: {},
    }
  },
  mounted() {},
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getPrimaryButtonClass: Fandom.getPrimaryButtonClass,
    getProductButtonClass(btnName) {
      if(btnName == this.productGridFilter) {
        return "btn-primary";
      } else {
        return "btn-outline-primary";
      }
    },
    isItemSelectable(item, efName) {
      return !includes(this.currentUser[efName], item);
    },
    getAccessoryButtonClass(btnName) {
      if(btnName == this.accessoryGridFilter) {
        return "btn-primary";
      } else {
        return "btn-outline-primary";
      }
    },
    changeProductGridFilter(efName) {
      this.productGridFilter = efName;
    },
    changeAccessoryGridFilter(efName) {
      this.accessoryGridFilter = efName;
    },
    addOwnedProduct() {
      this.updateUserProductAccessoriesInfo("owned_products", "add", this.ownedProductSelected.name);
    },
    removeOwnedProduct(product_name) {
      this.updateUserProductAccessoriesInfo("owned_products", "remove", product_name);
    },
    addDesiredProduct() {
      this.updateUserProductAccessoriesInfo("desired_products", "add", this.desiredProductSelected.name);
    },
    removeDesiredProduct(product_name) {
      this.updateUserProductAccessoriesInfo("desired_products", "remove", product_name);
    },
    addOwnedAccessory() {
      this.updateUserProductAccessoriesInfo("owned_accessories", "add", this.ownedAccessorySelected.name);
    },
    removeOwnedAccessory(accessory_name) {
      this.updateUserProductAccessoriesInfo("owned_accessories", "remove", accessory_name);
    },
    addDesiredAccessory() {
      this.updateUserProductAccessoriesInfo("desired_accessories", "add", this.desiredAccessorySelected.name);
    },
    removeDesiredAccessory(accessory_name) {
      this.updateUserProductAccessoriesInfo("desired_accessories", "remove", accessory_name);
    },
    removeProduct(product_name) {
      if(this.productGridFilter == "owned_products") {
        this.removeOwnedProduct(product_name);
      } else {
        this.removeDesiredProduct(product_name);
      }
    },
    removeAcessory(accessory_name) {
      if(this.accessoryGridFilter == "owned_accessories") {
        this.removeOwnedAccessory(accessory_name);
      } else {
        this.removeDesiredAccessory(accessory_name);
      }
    },
    resetSelected() {
      this.ownedProductSelected = null;
      this.desiredProductSelected = null;
      this.ownedAccessorySelected = null;
      this.desiredAccessorySelected = null;
    },
    updateUserProductAccessoriesInfo(extrafieldName, action, item) {
      Vue.set(this.userUpdating, extrafieldName, true);
      // this.userUpdating[extrafieldName] = true;
      Fandom.ajax({
        method: "POST",
        url: "/api/v5/update_user_product_accessories_info",
        data: {
          extra_field_name: extrafieldName,
          action_name: action,
          item: item
        },
        success: (data) => {
          if(!Fandom.exists(data.errors)) {
            // google analytics
            switch (extrafieldName) {
              case "owned_products":
                if (action === "add") {
                  sendFandomAnalyticsEvent("Product Assignment", "Owned Product Upload", this.getItemInfo(item).title);
                }
                break;
              case "desired_products":
                if (action === "add") {
                  sendFandomAnalyticsEvent("Product Assignment", "Desired Product Upload", this.getItemInfo(item).title);
                }
                break;
              case "owned_accessories":
                if (action === "add") {
                  sendFandomAnalyticsEvent("Accessory Assignment", "Owned Accessory Upload", this.getItemInfo(item).title);
                }
                break;
              case "desired_accessories":
                if (action === "add") {
                  sendFandomAnalyticsEvent("Accessory Assignment", "Desired Accessory Upload", this.getItemInfo(item).title);
                }
                break;
            }
            setTimeout(() => {
              Vue.set(this.userUpdating, extrafieldName, false);
              this.resetSelected();
              if(action == "add") {
                if(!Fandom.exists(this.currentUser[extrafieldName])) {
                  this.currentUser[extrafieldName] = [];
                }
                this.currentUser[extrafieldName].push(item);
              } else {
                remove(this.currentUser[extrafieldName], function(n) {
                  return n == item;
                });
              }
            }, 1000);
          } 
        },
      });
    },
    setOwnedProductSelected(item) {
      this.ownedProductSelected = item;
    },
    setDesiredProductSelected(item) {
      this.desiredProductSelected = item;
    },
    setOwnedAccessorySelected(item) {
      this.ownedAccessorySelected = item;
    },
    setDesiredAccessorySelected(item) {
      this.desiredAccessorySelected = item;
    },
    getItemInfo(itemName) {
      return this.pageModel.name_to_content[itemName];
    },
    isUpdateInProgress(efName) {
      console.log(">>>", efName);
      return Fandom.exists(this.userUpdating[efName]) && this.userUpdating[efName];
    },
  },
  computed: {
    products() {
      if(this.content.products) {
        return this.pageModel.name_to_content[this.content.products].children;
      } else {
        return null;
      }
    },
    accessories() {
      if(this.content.accessories) {
        return this.pageModel.name_to_content[this.content.accessories].children;
      } else {
        return null;
      }
    },
  },
};

</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentType" 
    stripe-user-products
  >
    <div class="selection-area py-4">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-12 col-md-6 selection-column">
                <p class="dropdown-label">
                  {{ft("user_edit.add_owned_products")}}
                </p>
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span v-if="ownedProductSelected"><img width="30" :src="ownedProductSelected.thumbnail.url" /> {{ownedProductSelected.title}}</span>
                    <span v-else>{{ft("user_edit.owned_products_label")}}</span>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a v-for="product in products" class="dropdown-item" href="javascript:void(0)" @click="setOwnedProductSelected(getItemInfo(product))" v-if="isItemSelectable(product, 'owned_products')"><img width="25" :src="getItemInfo(product).thumbnail.url" /> {{getItemInfo(product).title}}</a>
                  </div>
                </div>
                <div class="d-flex align-items-end flex-column pt-3">
                  <button @click="addOwnedProduct()" :disabled="isUpdateInProgress('owned_products')" class="confirm-button btn text-center ml-auto py-4 btn-primary">
                    <span v-if="isUpdateInProgress('owned_products')">{{ft("globals.updating")}}</span>
                    <span v-else>{{ft("globals.save")}}</span>
                  </button>
                </div>
              </div>
              <div class="col-12 col-md-6 selection-column">
                <p class="dropdown-label">
                  {{ft("user_edit.add_desired_products")}}
                </p>
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span v-if="desiredProductSelected"><img width="30" :src="desiredProductSelected.thumbnail.url" /> {{desiredProductSelected.title}}</span>
                    <span v-else>{{ft("user_edit.desired_products_label")}}</span>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a v-for="product in products" v-if="isItemSelectable(product, 'desired_products')" class="dropdown-item" href="javascript:void(0)" @click="setDesiredProductSelected(getItemInfo(product))"><img width="25" :src="getItemInfo(product).thumbnail.url" /> {{getItemInfo(product).title}}</a>
                  </div>
                </div>
                <div class="d-flex align-items-end flex-column pt-3">
                  <button @click="addDesiredProduct()" :disabled="isUpdateInProgress('desired_products')" class="confirm-button btn text-center ml-auto py-4 btn-primary">
                    <span v-if="isUpdateInProgress('desired_products')">{{ft("globals.updating")}}</span>
                    <span v-else>{{ft("globals.save")}}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4">
      <div class="container">
        <div class="row py-3">
          <div class="col-12">
            <h2 class="h3 mb-3">{{ft("user_edit.products")}}</h2>
            <a href="javascript:void(0)" :class="getProductButtonClass('owned_products')" @click="changeProductGridFilter('owned_products')" class="btn rounded-pill py-2 px-5 mb-3 product-accessory-grid-btn">{{ft("user_edit.own")}}</a>
            <a href="javascript:void(0)" :class="getProductButtonClass('desired_products')" @click="changeProductGridFilter('desired_products')" class="btn rounded-pill py-2 px-5 mb-3 product-accessory-grid-btn">{{ft("user_edit.desire")}}</a>
          </div>
        </div>
        <div class="row no-gutters" v-if="currentUser[productGridFilter] && currentUser[productGridFilter].length > 0">
          <div class="col-12 col-md-3" v-for="product in currentUser[productGridFilter]" v-if="getItemInfo(product)">
            <div class="product-box w-100">
              <div class="position-absolute-center bg-transition" tile-component>
                <div class="container-fluid h-100 p-0 d-flex flex-column justify-content-between">
                  <div class="bg-cover-center position-absolute-center bg" :style="{'background-image': getBackgroundUrl(getItemInfo(product).thumbnail.url)}"></div>
                  <div class="delete" @click="removeProduct(product)">
                    <i class="fal fa-minus-circle"></i>
                  </div>
                  <div class="row tile__bottom mx-0 pb-3 pb-md-2">
                    <div class="col-12 px-3 px-md-4 pt-3">
                      <div class="title-simple">
                        <h3 class="h5 m-0 title-italic">{{getItemInfo(product).title}}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row py-4" v-else>
          <div class="col-12">
            <p>
              {{ft("user_edit.empty_products")}}
            </p>
          </div>
        </div>
      </div>
    </div>
    
    <div class="selection-area py-4">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-12 col-md-6 selection-column">
                <p class="dropdown-label">
                  {{ft("user_edit.add_owned_accessories")}}
                </p>
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span v-if="ownedAccessorySelected"><img width="30" :src="ownedAccessorySelected.thumbnail.url" /> {{ownedAccessorySelected.title}}</span>
                    <span v-else>{{ft("user_edit.owned_accessories_label")}}</span>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a v-for="accessory in accessories" class="dropdown-item" href="javascript:void(0)" @click="setOwnedAccessorySelected(getItemInfo(accessory))" v-if="isItemSelectable(accessory, 'owned_accessories')">
                      <img width="25" :src="getItemInfo(accessory).thumbnail.url" /> {{getItemInfo(accessory).title}}
                    </a>
                  </div>
                </div>
                <div class="d-flex align-items-end flex-column pt-3">
                  <button @click="addOwnedAccessory()" :disabled="isUpdateInProgress('owned_accessories')" class="confirm-button btn text-center ml-auto py-4 btn-primary">
                    <span v-if="isUpdateInProgress('owned_accessories')">{{ft("globals.updating")}}</span>
                    <span v-else>{{ft("globals.save")}}</span>
                  </button>
                </div>
              </div>
              <div class="col-12 col-md-6 selection-column">
                <p class="dropdown-label">
                  {{ft("user_edit.add_desired_accessories")}}
                </p>
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span v-if="desiredAccessorySelected"><img width="30" :src="desiredAccessorySelected.thumbnail.url" /> {{desiredAccessorySelected.title}}</span>
                    <span v-else>{{ft("user_edit.desired_accessories_label")}}</span>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a v-for="accessory in accessories" v-if="isItemSelectable(accessory, 'desired_accessories')" class="dropdown-item" href="javascript:void(0)" @click="setDesiredAccessorySelected(getItemInfo(accessory))">
                      <img width="25" :src="getItemInfo(accessory).thumbnail.url" /> {{getItemInfo(accessory).title}}
                    </a>
                  </div>
                </div>
                <div class="d-flex align-items-end flex-column pt-3">
                  <button @click="addDesiredAccessory()" :disabled="isUpdateInProgress('desired_accessories')" class="confirm-button btn text-center ml-auto py-4 btn-primary">
                    <span v-if="isUpdateInProgress('desired_accessories')">{{ft("globals.updating")}}</span>
                    <span v-else>{{ft("globals.save")}}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4">
      <div class="container">
        <div class="row py-3">
          <div class="col-12">
            <h2 class="h3 mb-3">{{ft("user_edit.accessories")}}</h2>
            <a href="javascript:void(0)" :class="getAccessoryButtonClass('owned_accessories')" @click="changeAccessoryGridFilter('owned_accessories')" class="btn rounded-pill py-2 px-5 mb-3 product-accessory-grid-btn">{{ft("user_edit.own")}}</a>
            <a href="javascript:void(0)" :class="getAccessoryButtonClass('desired_accessories')" @click="changeAccessoryGridFilter('desired_accessories')" class="btn rounded-pill py-2 px-5 mb-3 product-accessory-grid-btn">{{ft("user_edit.desire")}}</a>
          </div>
        </div>
        <div class="row no-gutters" v-if="currentUser[accessoryGridFilter] && currentUser[accessoryGridFilter].length > 0">
          <div class="col-12 col-md-3" v-for="accessory in currentUser[accessoryGridFilter]" v-if="getItemInfo(accessory)">
            <div class="product-box w-100">
              <div class="position-absolute-center bg-transition" tile-component>
                <div class="container-fluid h-100 p-0 d-flex flex-column justify-content-between">
                  <div class="bg-cover-center position-absolute-center bg" :style="{'background-image': getBackgroundUrl(getItemInfo(accessory).thumbnail.url)}"></div>
                  <div class="delete" @click="removeAcessory(accessory)">
                    <i class="fal fa-minus-circle"></i>
                  </div>
                  <div class="row tile__bottom mx-0 pb-3 pb-md-2">
                    <div class="col-12 px-3 px-md-4 pt-3">
                      <div class="title-simple">
                        <h3 class="h5 m-0 title-italic">{{getItemInfo(accessory).title}}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row py-4" v-else>
          <div class="col-12">
            <p>
              {{ft("user_edit.empty_accessories")}}
            </p>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-user-products] {
  
  .selection-column:first-child {
    @include media-breakpoint-up(md) {
      padding-right: 3rem;
      border-right: 1px solid #979797;
    }
    @include media-breakpoint-down(md) {
      padding-bottom: 3rem;
    }
  }
  
  .confirm-button {
    @include media-breakpoint-down(md) {
      display: block;
      margin: 0;
      width: 100%;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
  
  .selection-column {
    @include media-breakpoint-up(md) {
      padding-left: 3rem;
    }
  }

  .dropdown-toggle, .dropdown-toggle:hover, .dropdown-toggle:active, .dropdown-toggle:focus {
    display: block;
    background-color: white !important;
    border: 1px solid whitesmoke !important;
    width: 100%;
    box-shadow: none !important;
    outline: none;
    text-align: left;
    padding: 1rem 10px;
    min-height: 65px;
  }
  
  .dropdown-toggle::after {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
  }
  
  .selection-area {
    background-color: $kenwood-light-grey;
  }
  .dropdown-menu.show {
    right: 0;
    z-index: 9999;
  }
  
  .product-box {
    position: relative;
    padding-bottom: 100%;
  }
  
  .tile__bottom {
    position: absolute;
    bottom: 0;
  }
  
  .product-accessory-grid-btn {
    text-transform: capitalize;
  }
  
  .delete {
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: black;
    font-size: 1.5rem;
    cursor: pointer;
  }
}
</style>
